export default class GenericRESTClient {
    url;
    constructor(url) {
        this.url = url;
    }
    async makeRequest(method, path, body, decodeResponse) {
        try {
            let fetchBody;
            if (body !== undefined) {
                if (body instanceof Blob) {
                    fetchBody = body;
                }
                else {
                    fetchBody = JSON.stringify(body);
                }
            }
            const rawRsp = await fetch(`${this.url}${path}`, {
                mode: 'cors',
                method,
                headers: {
                    'Content-Type': body instanceof Blob ? body.type : 'application/json',
                },
                body: fetchBody,
            });
            const isErrorHTTPCode = rawRsp.status < 200 || rawRsp.status > 299;
            if (isErrorHTTPCode) {
                // attempt parsing response as JSON.
                try {
                    const rawJson = await rawRsp.json();
                    return {
                        type: 'error',
                        status: rawRsp.status,
                        error: rawJson?.error || 'Internal REST Service error.',
                    };
                }
                catch (parseError) {
                    return {
                        type: 'error',
                        status: rawRsp.status,
                        error: 'Failed to read error body.',
                    };
                }
            }
            let rawJson;
            if (decodeResponse === undefined || decodeResponse) {
                try {
                    rawJson = await rawRsp.json();
                }
                catch (parseError) {
                    return {
                        type: 'error',
                        status: rawRsp.status,
                        error: 'Failed to read response body.',
                    };
                }
            }
            // all OK, return success response
            return {
                type: 'success',
                status: rawRsp.status,
                data: rawJson,
            };
        }
        catch (e) {
            return {
                type: 'error',
                status: e?.status || 0,
                error: e?.error || 'Internal REST Service error.',
            };
        }
    }
}
